export const Display = {
  FLEX: 'flex',
}

export const Direction = {
  ROW: 'row',
  COLUMN: 'column',
}

/**
 * Dimension enum, width and height.
 * @readonly
 * @enum {string}
 */
export const Dimension = {
  WIDTH: 'width',
  HEIGHT: 'height',
}

export const DimensionMax = {
  [Dimension.WIDTH]: 'maxWidth',
  [Dimension.HEIGHT]: 'maxHeight',
}

export const DimensionMin = {
  [Dimension.WIDTH]: 'minWidth',
  [Dimension.HEIGHT]: 'minHeight',
}

/**
 * Axis enum, x and y.
 * @readonly
 * @enum {string}
 */
export const Axis = {
  X: 'x',
  Y: 'y',
}

/**
 * Unit enum.
 * @readonly
 * @enum {string}
 */
export const Unit = {
  PX: 'px',
  PERCENTAGE: '%',
}

export const Wrap = {
  WRAP: 'wrap',
  NOWRAP: 'nowrap',
}

export const Justify = {
  FLEX_START: 'flex-start',
  FLEX_END: 'flex-end',
  CENTER: 'center',
  SPACE_BETWEEN: 'space-between',
  SPACE_AROUND: 'space-around',
  SPACE_EVENLY: 'space-evenly',
}

export const AlignItems = {
  FLEX_START: 'flex-start',
  FLEX_END: 'flex-end',
  STRETCH: 'stretch',
  CENTER: 'center',
  START: 'start',
  END: 'end',
}

export const JUSTIFY_SPACING_SIZE_MODIFIERS = {
  [Justify.SPACE_BETWEEN]: -1,
  [Justify.SPACE_AROUND]: 0,
  [Justify.SPACE_EVENLY]: 1,
}
export const JUSTIFY_SPACING_MODIFIER = {
  [Justify.SPACE_BETWEEN]: 1,
  [Justify.SPACE_AROUND]: 0.5,
  [Justify.SPACE_EVENLY]: 0,
}

export const Position = {
  ABSOLUTE: 'absolute',
  STATIC: 'static',
  RELATIVE: 'relative',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
}

export const Margin = {
  TOP: 'marginTop',
  RIGHT: 'marginRight',
  BOTTOM: 'marginBottom',
  LEFT: 'marginLeft',
}

export const Padding = {
  TOP: 'paddingTop',
  RIGHT: 'paddingRight',
  BOTTOM: 'paddingBottom',
  LEFT: 'paddingLeft',
}

export const BorderStyle = {
  NONE: 'none',
  SOLID: 'solid',
  DASHED: 'dashed',
}

export const Side = {
  TOP: 'Top',
  RIGHT: 'Right',
  BOTTOM: 'Bottom',
  LEFT: 'Left',
}

export const BorderSideWidth = {
  [Side.TOP]: 'borderTopWidth',
  [Side.RIGHT]: 'borderRightWidth',
  [Side.BOTTOM]: 'borderBottomWidth',
  [Side.LEFT]: 'borderLeftWidth',
}

export const BorderSideStyle = {
  [Side.TOP]: 'borderTopStyle',
  [Side.RIGHT]: 'borderRightStyle',
  [Side.BOTTOM]: 'borderBottomStyle',
  [Side.LEFT]: 'borderLeftStyle',
}

export const BorderOption = {
  STYLE: 'Style',
  WIDTH: 'Width',
  COLOR: 'Color',
  RADIUS: 'Radius',
}

export const TextAlign = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
}

export const WhiteSpace = {
  NOWRAP: 'nowrap',
}
